// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".typing-title[data-v-4381e66a]{text-align:left;margin-bottom:unset}", "",{"version":3,"sources":["webpack://src/components/shared/TypingTitle.vue"],"names":[],"mappings":"AAAA,+BAA+B,eAAe,CAAC,mBAAmB","sourcesContent":[".typing-title[data-v-4381e66a]{text-align:left;margin-bottom:unset}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
